import { FC, JSX } from "react";
import "./CSS/HomeScreen.css";
import ProfileScreen from "../Profile Screen/ProfileScreen";
import { MENU_ITEM } from "../../utils/constants";
import HomeScreenTabBar from "./Views/HomeScreenTabBar";
import CalendarScreen from "screens/Calendar Screen/CalendarScreen";
import MembershipScreen from "screens/Membership Screen/MembershipScreen";
import DashboardScreen from "screens/Dashboard Screen/DashboardScreen";
import { useTabBar } from "services/TabBarProvider";

const HomeScreen: FC = () => {
  const { selectedTabBar, setSelectedTabBar } = useTabBar();

  const renderContent = (): JSX.Element => {
    switch (selectedTabBar) {
      case MENU_ITEM.HOME:
        return <DashboardScreen />;
      case MENU_ITEM.CALENDAR:
        return <CalendarScreen />;
      case MENU_ITEM.MEMBERSHIP:
        return <MembershipScreen />;
      default:
        return <ProfileScreen />;
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="home-screen-wrapper">
        <div className="home-screen-main-content">{renderContent()}</div>
        <HomeScreenTabBar
          activeTab={selectedTabBar}
          setActiveTab={setSelectedTabBar}
        />
      </div>
    </div>
  );
};

export default HomeScreen;
